<template>
  <div class="my">
    <header>田野商城</header>
    <!-- 导航 -->
    <main>
      <!-- 客户信息 -->
      <div class="custormerInfo">
        <img src="../assets/头像图片.png" alt />
        <van-row class="my-com">
          <van-col span="24">{{custormerInfo.name}}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="6" class="my-name" id="my_name">{{custormerInfo.contactName}}</van-col>
          <van-col span="6" class="my-esc" @click="esc">退出登录</van-col>
        </van-row>
      </div>
      <!-- 我的订单 -->
      <div class="my-order">
        我的订单
        <van-divider />
        <van-row>
          <van-col span="4" class="order-col" @click="goSend('/orderList/send')">
            <img class="order-img" src="../assets/img/待发货@2x.png" alt />
            <p class="order-p">待发货</p>
          </van-col>
          <van-col span="4" class="order-col" @click="goSend('/orderList/harvested')">
            <img class="order-img" src="../assets/img/待收货@2x.png" alt />
            <p class="order-p">待收货</p>
          </van-col>
          <van-col span="4" class="order-col" @click="goSend('/orderList/reconciliation')">
            <img class="order-img" src="../assets/img/待对账@2x.png" alt />
            <p class="order-p">待对账</p>
          </van-col>
          <van-col span="4" class="order-col" @click="goSend('/orderList/succeed')">
            <img class="order-img" src="../assets/img/已完成@2x.png" alt />
            <p class="order-p">已完成</p>
          </van-col>
          <van-col span="4" class="order-col" @click="goSend('/orderList/defeated')">
            <img class="order-img" src="../assets/img/已关闭@2x.png" alt />
            <p class="order-p">已关闭</p>
          </van-col>
          <van-col span="4" class="order-col" @click="goSend('/expense/list')">
            <img class="order-img" src="../assets/img/order.png" alt />
            <p class="order-p">补货</p>
          </van-col>
        </van-row>
      </div>

      <!-- 我的工具 -->
      <div class="my-order">
        我的工具
        <van-divider />
        <van-row>
          <!-- <van-col span="4" class="order-col" @click="goSend('/Replenishment')">
            <img class="order-img" src="../assets/img/补货@2x(1).png" alt />
            <p class="order-p">补货</p>
          </van-col> -->
          <van-col span="4" class="order-col" @click="goSend('datumList')">
            <img class="order-img" src="../assets/img/补货@2x(1).png" alt />
            <p class="order-p">资料列表</p>
          </van-col>
        </van-row>
      </div>
    </main>
    <div class="order-foot-div">
      <p class="order-foot-p" @click="goSend('/protocol')">《田野用户服务协议》</p>
    </div>
     <tabbar :activeNew='active' />
 
  </div>
</template>

<script>
import tabbar from "./common/tabbar";
export default {
  components:{
tabbar
  },
  created() {
    //  获取客户信息
    this.$axios.get("/customer/customer/info").then(res => {
      this.custormerInfo = res.data.data;
      let nameWidth = document.getElementById('my_name')
      nameWidth.style.width = this.custormerInfo.contactName.length * 20 + 'px'
    });
  },
  data() {
    return {
      active: 3,
      custormerInfo: {}
    };
  },
  methods: {
    // 退出
    esc() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认要退出？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          // on confirm
          localStorage.removeItem("token");
          this.$router.push("/accountLogin");
        })
        .catch(() => {
          // on cancel
        });
    },
    // 页面转跳
    goSend(url) {
      this.$router.push(url);
      
    },
  }
};
</script>

<style scoped>
.my {
  background: rgba(242, 242, 242, 1);
  padding-top: 40px;
}
header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding-left: 20px;
  line-height: 40px;
  background: #e7e7e7;
  position: fixed;
  top: 0;
  width: 100%;
}
main {
  background-color: #f2f2f2;
}
.custormerInfo {
  width: 95%;
  height: 60px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  margin: 30px auto;
  position: relative;
  padding-left: 22%;
  box-sizing: border-box;
  background: url("../assets/头像背景.png") center center repeat;
}
.custormerInfo img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  position: absolute;
  top: -20%;
  left: 3%;
}
.my-com {
  padding-top: 5px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: rgba(116, 180, 43, 1);
}
.my-name {
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0.5) 0%,
    rgba(116, 180, 43, 0) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 17px;
  padding-left: 3px;
}
.my-esc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
  text-decoration: underline;
}
.my-order {
  width: 95%;
  height: 110px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}
.van-divider {
  margin: 13px 0;
}
.order-img {
  width: 28px;
  height: 25px;
}
.order-col {
  text-align: center;
}
.order-p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.order-foot-p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
  text-align: center;
  text-decoration: underline;
}
.order-foot-div {
  position: fixed;
  left: 30%;
  bottom: 10%;
}
.van-divider[data-v-134989dc] {
  margin: 6px 0 14px;
}
</style>